// 見切り反撃の動きを、回避の低い止まり姿から直接伸び上がる形にする (2026-10-09 夜に比較版 → 同日ユーザー採用「直す」で配布版の既定)。
//   旧 (素立ちから始まる counter・混ぜ 0.12 s) は DEV の ?counterFromDodge=0 で比べられる。
//   本番化の記録 = docs/research/2026-10-09-prod-switch-brace-finisher-counter.md
//   10-09 ユーザー「回避反撃はエフェクトやモーションをブラッシュアップしてほしい」→ 調べ docs/research/2026-10-09-dodge-counter-polish-research.md 案1 の動き。
//   今の反撃 (Spine の counter) は素立ちから始まり、回避 (dodge_d_lop) の低い姿勢から Spine の既定の混ぜ 0.12 s で繋ぐ
//   = 混ぜの間に体が素立ちの方へ浮き上がり、0.045 s の沈み込みが見えない (静止画で確かめた・
//   C:\dev\LUNAIRE-notes\assets\2026-10-09-dodge-counter\motion\compare_now_vs_new.png)。
//   新しい counter_from_dodge は最初のキーが回避の止まり姿で、回避 → 反撃の混ぜは 0 (scripts/author_player_study_motions.mjs が作る)。
//   描くだけの違い: 当たりの時間・距離・判定は変えない (player.ts / combat.ts はこのファイルを読まない)。
//   スイッチ (?counterFromDodge=0|1) は game.ts の DEV の箱の中でだけ読む。配布版は下の既定 (true) のまま。

/** 回避の止まり姿から始まる反撃のアニメ名 (本番の skeleton_ik_skirt.json に注入済み) */
export const COUNTER_FROM_DODGE_ANIM = 'counter_from_dodge'

/** 回避 → 反撃の混ぜ (Spine の setMix)。 counter_from_dodge の最初のキー = dodge_d_lop の止まり姿なので 0。
 *  他の姿 (素立ち・別の回避) から入った時は既定の混ぜのまま。
 *  止まり姿から外れた時刻で押した時は、下の counterFromDodgeBlend が押した時刻ごとに 2〜3 コマ混ぜる (2026-10-09 夜)。 */
export const COUNTER_FROM_DODGE_MIX: readonly (readonly [from: string, to: string, mix: number])[] = [
  ['dodge_d_lop', COUNTER_FROM_DODGE_ANIM, 0],
]

// 既定 = 回避の止まり姿から始める (10-09 ユーザー採用・配布版)。
let fromDodge = true

/** DEV の URL の値を受け取る (0 で旧の counter・それ以外 (指定なし・1) は既定の新しい反撃) */
export function setDodgeCounterMotion(value: string | null): void {
  fromDodge = value !== '0'
}

/** 見切り反撃に使う Spine のアニメ名 */
export function counterAnimationName(): string {
  return fromDodge ? COUNTER_FROM_DODGE_ANIM : 'counter'
}

// ---- 早めに・遅めに押した時の跳びを混ぜで消す (2026-10-09 夜・破綻の修正なので配布版の既定) ----
//   counter_from_dodge の最初のキーは回避の止まり姿 (dodge_d_lop の 4 番目のキー・骨ごとに 0.342〜0.417 s)。
//   止まり姿の時刻で押せば混ぜ 0 で1コマも跳ばないが、回避が明けてすぐ (0.267 s) 押すと、まだ後ろへ大きく振っている
//   剣を持たない腕が1コマで 36 px・髪が 30 px 跳び、立ち上がりの途中 (0.45〜0.55 s) で押すと体ごと 20〜30 px・
//   剣を持たない腕は 50〜59 px 落ちる (主人公の高さ 120 px の大きさ・scripts/measure_counter_blend.ts・
//   docs/research/2026-10-09-dodge-counter-early-press-blend.md)。
//   直し方 = 止まり姿から外れた時刻で押した時だけ 2〜3 コマ混ぜる。 混ぜの間は回避の時計を止める (押した瞬間の姿から反撃へ寄せる。
//   止めないと、早めに押した時は回避が腕を振り続け・立ち上がりの途中で押した時は体が浮き続けて、跳びが残る)。
//   混ぜは 3 コマまで = 反撃の突き出し (0.033→0.05 s のコマで剣先が 39 px 走る) より前に混ぜ終わる = 突きの鋭さは変えない
//   (4 コマ以上混ぜると突きの1コマが 39 → 32 px に鈍った・測りの表は研究文書)。
//   止まり姿の近く (下の窓) では混ぜ 0 のまま = ユーザーが良しとした「沈んでから突く」をそのまま残す。
//   当たりの時間・受付・ダメージは変えない (描くだけ。 player.ts / combat.ts はこのファイルを読まない)。
//   直す前 (いつでも混ぜ 0) は DEV の ?counterBlend=0 で比べられる (game.ts の DEV の箱の中でだけ読む)。

/** 止まり姿の真ん中の時刻 (骨ごとの 4 番目のキー 0.342〜0.417 s のうち、混ぜ 0 で跳びが小さい 0.34〜0.37 s の真ん中) */
export const COUNTER_FROM_DODGE_STOP_SEC = 0.355
/** 止まり姿で押した時の時刻 (脚・剣の腕の 4 番目のキー。 ユーザーが見て良しとした押し方。 測りの物差し) */
export const COUNTER_FROM_DODGE_REFERENCE_PRESS_SEC = 0.3666667
/** 止まり姿から この秒数までは混ぜ 0 (0.34〜0.37 s) */
const STOP_WINDOW_SEC = 0.015
/** 止まり姿から 1 秒離れるごとの混ぜの秒数 */
const MIX_PER_SEC = 1.0
/** 混ぜの上限 (3 コマ)。 反撃の突き出しのコマより前に混ぜ終わる */
const MIX_MAX_SEC = 3 / 60
/** 混ぜを入れる時の下限 (2 コマ)。 1 コマより短い混ぜは最初のコマで混ぜ終わって効かない */
const MIX_MIN_SEC = 2 / 60

let blend = true

/** DEV の URL の値を受け取る (0 で直す前 = いつでも混ぜ 0・それ以外 (指定なし・1) は既定の混ぜあり) */
export function setCounterBlend(value: string | null): void {
  blend = value !== '0'
}

/** 回避の何秒目で押したかから、反撃へ入る混ぜを決める。 回避 (dodge_d_lop) から counter_from_dodge へ入る時だけ。
 *  @returns null = 何もしない (setMix で登録した混ぜ 0 のまま)。
 *           mixSec = その時だけの混ぜ・fromTimeScale = 混ぜの間の回避の時計 (0 = 押した瞬間の姿で止める) */
export function counterFromDodgeBlend(
  fromAnim: string | null, toAnim: string, fromTimeSec: number,
): { mixSec: number, fromTimeScale: number } | null {
  if (!blend || fromAnim !== 'dodge_d_lop' || toAnim !== COUNTER_FROM_DODGE_ANIM) return null
  const off = Math.max(0, Math.abs(fromTimeSec - COUNTER_FROM_DODGE_STOP_SEC) - STOP_WINDOW_SEC)
  if (off <= 0) return null
  const mixSec = Math.min(MIX_MAX_SEC, Math.max(MIX_MIN_SEC, off * MIX_PER_SEC))
  return { mixSec, fromTimeScale: 0 }
}

/** Spine の TrackEntry のうち、ここで読む・書く所だけ (spine を import しない = テスト・測りの台本からも使える) */
interface BlendTrackEntry { animation: { name: string } | null, trackTime: number, timeScale: number }

/** 切り替えた直後に呼ぶ: prev = setAnimation 前のトラックの再生中 (無ければ null)・next = setAnimation が返したもの。
 *  回避 → counter_from_dodge の時だけ、押した時刻に合わせて next の混ぜを決め、prev (回避) の時計を止める。
 *  src/spine_player.ts と scripts/measure_counter_blend.ts が同じこれを通す (ゲームと測りがずれない)。
 *  @returns 入れた混ぜの秒数 (何もしなかった時は null) */
export function applyCounterFromDodgeBlend(
  prev: BlendTrackEntry | null, next: { mixDuration: number }, toAnim: string,
): number | null {
  const plan = counterFromDodgeBlend(prev?.animation?.name ?? null, toAnim, prev?.trackTime ?? 0)
  if (!plan || !prev) return null
  next.mixDuration = plan.mixSec
  prev.timeScale = plan.fromTimeScale
  return plan.mixSec
}
